import { useModalStore } from "store/modal/hooks/useModalStore";

import { DeleteBidModal } from "./delete-bid-modal";
import { RejectAfterWinningModal } from "./reject-after-winning-modal";
import ReopenApplicationModal from "./reopen-application-modal";

const Modal = () => {
  const modalParams = useModalStore((state) => state.modalParams);

  return (
    <>
      {modalParams?.type === "reopen" && <ReopenApplicationModal />}
      {modalParams?.type === "rejectAfterWinning" && (
        <RejectAfterWinningModal />
      )}
      {modalParams?.type === "deleteBid" && <DeleteBidModal />}
    </>
  );
};

export { Modal };
